<script>
    import {getContext, onDestroy, tick} from "svelte";

    export let step;
    export let stepComplete;

    let {org, product, shopData, serviceProviders, matchkey, location} = getContext("SHOP");
    let providerError = '';
    let locationError = '';
    let forceSelectLocation = false;
    let providers = [];

    let type = org.type;

    const serviceProviderTypes = {
        Health: 'Doctor',
        Gym: 'Coach',
        'Tactical & First Responders':"Director"
    }

    async function handleSelectProvider(e) {
      await tick();
      if(!$shopData.isLocationSpecific){ // we alreay know the location, we are just choosing the providers at this location
        if (!$location && !(type === 'Gym' || type == 'Tactical & First Responders')){
          let providerLocations = $shopData.serviceProvider.locations.filter(l => !l.is_private_study_location);
          if(providerLocations.length > 1) {
            forceSelectLocation = true
          }else{
            forceSelectLocation = false;
            $location = providerLocations[0];
            $shopData.location = providerLocations[0].guid;
          }
        }
      }
    }

    function handleResetProvider() {
        $shopData.serviceProvider = null;
        continuePurchase();
    }

    function handleSelectLocation() {
        locationError = null;
        console.log('Location changed', $location)
        if($location){
          $shopData.location = $location.guid;
        }
        providers = $serviceProviders.filter(p => p.locations.findIndex(l => l.guid === $shopData.location) > -1 || p.is_admin);
        if(providers.length == 1){
          $shopData.serviceProvider = providers[0];
        }else{
          $shopData.serviceProvider = null;
        }
    }

    function continuePurchase() {
        if ((type === 'Gym' || type == 'Tactical & First Responders') && !$shopData.location) {
            locationError = `Please add location`;
            return
        }
        if (type === 'Health' && !$shopData.serviceProvider) {
            providerError = `Please add referring ${serviceProviderTypes[type]}`;
            return
        }

        if($location){
          $shopData.location = $location.guid;
        }
        
        if (!$shopData.location && $shopData.serviceProvider) {
            let l = $shopData.serviceProvider.locations[0]; // might have to fix this later if we support multiple locations on each coach
            if (!l) {
              if (org.locations.length === 1) {
                l = org.locations[0].guid;
              } else {
                locationError = 'Please select location';
                return;
              }
            }else{
              $shopData.location = l.guid;
              $location = l;
            }
        }

        $shopData = $shopData;
        if(window.posthog) {
          window.posthog.capture('store-product-selected', {product: $shopData.productType});
        }

        if(step.validate()){
          stepComplete()
        }
    }

    const unsubscribe = serviceProviders.subscribe(s => {
        if (s && s.length) {
          console.log('providers loaded...', $shopData)
            providers = s;
            if (!$shopData.serviceProvider && providers.length) {
                let provider = $shopData.serviceProvider = $location ? providers[0] : providers.find( p => p.locations.length)[0];
                if(provider && provider.locations){
                  let providerLocations = provider.locations.filter(l => !l.is_private_study_location);
                  console.log({providerLocations})
                  if(providerLocations.length > 1) {
                    forceSelectLocation = true
                  }else{
                    $location = providerLocations[0];
                    $shopData.location = providerLocations[0].guid;
                    console.log('set locations....', $location)
                  }
                }
            }else if(!$shopData.isLocationSpecific && $shopData.serviceProvider ){
              let providerLocations = $shopData.serviceProvider.locations.filter(l => !l.is_private_study_location);
              if(providerLocations.length > 1) {
                forceSelectLocation = true
              }else if (!$location){
                $location = providerLocations[0];
                $shopData.location = providerLocations[0].guid
                console.log('set locations....', $location)
              }
            }
        }
    })

    onDestroy(unsubscribe);
</script>

<style lang="scss">

  .checkbox-input {
    // Code to hide the input
    clip: rect(0 0 0 0);
    clip-path: inset(100%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;

    &:checked + .checkbox-tile {
      border-color: black;
      box-shadow: 0 5px 10px rgba(#000, 0.1);
      color: black;

      &:before {
        transform: scale(1);
        opacity: 1;
        background-color: black;
        border-color: black;
      }

      .checkbox-icon, .checkbox-label {
        color: black;
      }
    }

    &:focus + .checkbox-tile {
      border-color: black;
      box-shadow: 0 5px 10px rgba(#000, 0.1), 0 0 0 4px #b5c9fc;

      &:before {
        transform: scale(1);
        opacity: 1;
      }
    }
  }

  .checkbox-tile {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 7rem;
    min-height: 7rem;
    border-radius: 0.5rem;
    border: 2px solid #b5bfd9;
    background-color: #fff;
    box-shadow: 0 5px 10px rgba(#000, 0.1);
    transition: 0.15s ease;
    cursor: pointer;
    position: relative;

    &.location {
      margin: 0 1.5rem;
      width: 9rem;
      height: 100%;
      padding: 0.5rem;
    }

    &:before {
      content: "";
      position: absolute;
      display: block;
      width: 1.25rem;
      height: 1.25rem;
      border: 2px solid #b5bfd9;
      background-color: #fff;
      border-radius: 50%;
      top: 0.25rem;
      left: 0.25rem;
      opacity: 0;
      transform: scale(0);
      transition: 0.25s ease;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='192' height='192' fill='%23FFFFFF' viewBox='0 0 256 256'%3E%3Crect width='256' height='256' fill='none'%3E%3C/rect%3E%3Cpolyline points='216 72.005 104 184 48 128.005' fill='none' stroke='%23FFFFFF' stroke-linecap='round' stroke-linejoin='round' stroke-width='32'%3E%3C/polyline%3E%3C/svg%3E");
      background-size: 12px;
      background-repeat: no-repeat;
      background-position: 50% 50%;
    }

    &:hover {
      border-color: black;

      &:before {
        transform: scale(1);
        opacity: 1;
      }
    }
  }

  .checkbox-icon {
    transition: .375s ease;
    color: #494949;

    i {
      font-size: 50px;
    }
  }

  .checkbox-label {
    color: #707070;
    transition: .375s ease;
    text-align: center;
  }

  .location-dropdowns {
    max-width:300px;
  }

</style>

<div class="provider-selection flex flex-col justify-center m-auto">
  {#if (type === 'Gym' || type === "Tactical & First Responders") && !$shopData.isLocationSpecific}
    <div class="location-dropdowns">
      <p class="my-3 text-gray-800 font-semibold">Please select a location.</p>
      <div class="pb-4 relative">
          <select
                  name="location-selection"
                  id="location"
                  bind:value={$location}
                  on:change={handleSelectLocation}
                  class:border-red-400={locationError}
                  class:border-gray-300={!locationError}
                  class="block w-full rounded-md border shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          >

              <option value="-1" disabled>Select a location from the list</option>
              {#each org.locations as loc}
                  {#if !loc.is_private_study_location}
                      <option value="{loc}">{loc.title}</option>
                  {/if}
              {/each}

          </select>
          {#if locationError}
              <div class="rounded-md text-sm text-red-500 bg-red-50 px-3 py-2 mb-3 mt-2">{locationError}</div>
          {/if}
      </div>
    </div>
{/if}
{#if (!matchkey || !(matchkey && matchkey.service_provider)) && (type !== 'Gym' || !!$shopData.location)}
    <div class="location-dropdowns">
      <p class="my-3 text-gray-800 font-semibold">Please choose your {serviceProviderTypes[type]}. {#if type === 'Gym'}(optional){/if}</p>
      <div class="pb-4 relative">
          <select
                  name="doctor-selection"
                  id="doctor"
                  bind:value={$shopData.serviceProvider}
                  on:change={handleSelectProvider}
                  class:border-red-400={providerError}
                  class:border-gray-300={!providerError}
                  class="block w-full rounded-md border shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          >

              <option value="-1" disabled>Select a {serviceProviderTypes[type]} from the list</option>
              {#each providers as provider (provider.guid)}
                  <option value="{provider}">{provider.firstname} {provider.lastname}
                      {#if !$shopData.location && provider.locations.length == 1}({provider.locations[0].title}){/if}
                  </option>
              {/each}

          </select>
          {#if providerError}
              <div class="rounded-md text-sm text-red-500 bg-red-50 px-3 py-2 mb-3 mt-2">{providerError}</div>
          {/if}
      </div>
    </div>
    {#if type === 'Gym'}
        <button class="underline" on:click={handleResetProvider}>Dont know my coach, assign me one</button>
    {/if}
    {#if forceSelectLocation}
        <p class="my-3 text-gray-800 font-semibold">Please select a location.</p>
        <div class="flex flex-wrap justify-center">
            {#each org.locations as loc}
                {#if !loc.is_private_study_location}
                    <div class="checkbox py-3">
                        <label class="checkbox-wrapper">
                            <input type="radio" class="checkbox-input" bind:group={$location}
                                   name="location" value={loc}/>
                            <span class="checkbox-tile location">
                              <span class="checkbox-icon ">
                                <i class="fa-duotone fa-building-user"></i>
                              </span>
                              <span class="checkbox-label my-2">{loc.title}</span>
                              {#if loc.address}
                              <span class="text-gray-600 text-center text-sm">{loc.address}</span>
                              {/if}
                          </span>
                        </label>
                    </div>
                {/if}
            {/each}
        </div>
        {#if locationError}
            <div class="rounded-md text-sm text-red-500 px-3 mb-3 mt-2">{locationError}</div>
        {/if}
    {/if}
{/if}
<button type="button" on:click={continuePurchase}
        class="mt-5 items-center rounded-md border border-transparent bg-black px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
    Continue
</button>
</div>
